<template>
    <div>
        <form data-vv-scope="documentsform" @submit.prevent="" @keydown.enter.prevent="" v-if="showEdit">
            <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                <div class="form-container pt-10 form-container-questionnaire">
                    <fileUploadNote :fileNote="true" />
                    <template v-if="callFromSponsorDocs">
                        <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'sponsorDocumentslist'"
                        :docslist="documentslist" :petition="petition" formscope="documentsform" :showTitle="true" :callfromPetitionDocs="true"
                        :fieldsArray="fieldsArray" v-model="petition.sponsorInfo.documents" :tplsection="'sponsorInfo.documents'"  :fieldName="''" ></casedocumentslist>
                    </template>
                    <template v-else-if="callFromPetitionerDocs">
                        <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'usaCompanyDocumentslist'" :title="'USA Company documents'"
                        :docslist="usaCompanyDocumentslist" :petition="petition" formscope="documentsform" :showTitle="true" :callfromPetitionDocs="true"
                        :fieldsArray="fieldsArray" v-model="petition.petitionerQuestInfo.usaCompanyDocuments" :tplsection="'petitionerQuestInfo.usaCompanyDocuments'"  :fieldName="''" ></casedocumentslist>
                        
                        <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'foreignCompanyDocumentsList'" :title="'Foreign Company documents'"
                        :docslist="foreignCompanyDocumentsList" :petition="petition" formscope="documentsform" :showTitle="true" :callfromPetitionDocs="true"
                        :fieldsArray="fieldsArray" v-model="petition.petitionerQuestInfo.foreignCompanyDocuments" :tplsection="'petitionerQuestInfo.foreignCompanyDocuments'"  :fieldName="''" ></casedocumentslist>
                    </template>
                    <template v-else>
                        <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'documentslist'"
                        :docslist="documentslist" :petition="petition" formscope="documentsform" :showTitle="true" :callfromPetitionDocs="true"
                        :fieldsArray="fieldsArray" v-model="petition.documents" :tplsection="'documents'"  :fieldName="''" ></casedocumentslist>
                    </template>
                    <template v-if="showSpouseDocs&&checkProperty(petition,'beneficiaryInfo', 'maritalStatusDetails')&&petition.beneficiaryInfo.maritalStatusDetails.id != 1">
                        <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'spouseDocsList'" 
                            :title="'List of Spouse documents needs to be updated'"
                            :docslist="spouseDocsList" :petition="petition" formscope="documentsform" :showTitle="true" :callfromPetitionDocs="true"
                            :fieldsArray="fieldsArray" v-model="petition.dependentsInfo.spouse.documents" :tplsection="'dependentsInfo.spouse.documents'"  :fieldName="''" >
                        </casedocumentslist>
                    </template>
                </div>
            </vs-col>
            <template >
                <div @click="formerrors.msg = ''" class="text-danger text-sm formerrors" v-show="formerrors.msg">
                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                    icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
                </div>

                <div class="popup-footer mt-4 relative">
                    <button class="btn cancel" @click="$emit('openEditDocs', false)">Cancel</button>
                    <button class="btn save" @click="updateDocumentsAction()" :disabled="documentUploading">
                    <figure class="loader" v-if="documentUploading"><img src="@/assets/images/main/loader.gif" /></figure>
                    <span>Update</span>
                    </button>
                </div>
            </template>
        </form>
    </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import casedocumentslist from "@/views/common/casedocuments.vue";
import fileUploadNote from "@/views/common/fileUploadNote.vue";
export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    data() {
        return {
            showEdit:false,
            spouseDocuments:{
                documents:null
            },
            formerrors:{
                msg:''
            },
            documentUploading:false,
            spouseDocsList:[],
            documentslist: [
                {
                    display:true,
                    required: false,
                    fileUploading:false,
                    key: 'copyOfRfe',
                    fieldName: 'copyOfRfe',
                    label: 'Copy of RFE'
                }, 
                {
                    display:true,
                    required: false,
                    fileUploading:false,
                    key: 'orgPetition',
                    fieldName: 'orgPetition',
                    label: 'Original Petition'
                }, 
                {
                    display:true,
                    required: false,
                    fileUploading:false,
                    key: 'petitionerDocs',
                    fieldName: 'petitionerDocs',
                    label: 'Petitioner Documents (if any)'
                }, 
                {
                    display:true,
                    required: false,
                    fileUploading:false,
                    key: 'beneficiaryDocs',
                    fieldName: 'beneficiaryDocs',
                    label: 'Beneficiary Documents'
                },  
                {
                    display:true,
                    required: false,
                    fileUploading:false,
                    key: 'employmentDocs',
                    fieldName: 'employmentDocs',
                    label: 'Employment Documents (if any)'
                }, 
                {
                    display:true,
                    required: false,
                    fileUploading:false,
                    key: 'other',
                    fieldName: 'other',
                    label: 'Others'
                }, 
            ],
            usaCompanyDocumentslist:[
                {
                    required: false,
                    fileUploading:false,
                    key:'incorporationCertDocs',
                    fieldName:"incorporationCertDocs",
                    label:'Certificate of Incorporation'
                },
                {
                    required: false,
                    fileUploading:false,
                    key:'amendmentCertDocs',
                    fieldName:"amendmentCertDocs",
                    label:'Certificate of Amendment of Certificate of Incorporation'
                },
                {
                    required: false,
                    fileUploading:false,
                    key:'stockCopyCertDocs',
                    label:'Copy of stock certificates',
                    fieldName:"stockCopyCertDocs",
                },
                {
                    required: false,
                    fileUploading:false,
                    key: 'curOrgaChart',
                    fieldName: 'curOrgaChart',
                    label: 'Current Organizational Chart '
                },  
                {
                    required: false,
                    fileUploading:false,
                    key: 'minOfBoardMeetings',
                    fieldName: 'minOfBoardMeetings',
                    label: 'Minutes of Board Meetings'
                }, 
                
                {
                    required: false,
                    fileUploading:false,
                    key: 'contraExecOfCopyDocs',
                    fieldName: 'contraExecOfCopyDocs',
                    label: 'Copy of the contracts executed'
                }, 
                
                {
                    required: false,
                    fileUploading:false,
                    key: 'auditFinaStatMostRecent',
                    fieldName: 'auditFinaStatMostRecent',
                    label: 'Most recent audited financial statements or Federal Tax Returns'
                },
                {
                    required: false,
                    fileUploading:false,
                    key: 'productDocs',
                    fieldName: 'productDocs',
                    label: 'Product Documents '
                }   
            ],
            foreignCompanyDocumentsList:[
                {
                    required: false,
                    key: 'taxReturns',
                    cid:'taxReturns',
                    fieldName: 'taxReturns',
                    label: 'Income tax Returns'
                },
                {
                    required: false,
                    fileUploading:false,
                    key: 'bankStatements',
                    fieldName: 'bankStatements',
                    cid: 'bankStatements',
                    label: 'Bank Statements'
                }, 
                {
                    required: false,
                    fileUploading:false,
                    key: 'verifyOrSupportLetter',
                    fieldName: 'verifyOrSupportLetter',
                    cid: 'verifyOrSupportLetter',
                    label: 'Verification/Support Letter'
                }, 
                {
                    required: false,
                    fileUploading:false,
                    key: 'orgnaStructureDocs',
                    fieldName: 'orgnaStructureDocs',
                    cid: 'orgnaStructureDocs',
                    label: 'Organization Structure'
                }, 
                {
                    required: false,
                    fileUploading:false,
                    key: 'proAndLossStatDocs',
                    cid: 'proAndLossStatDocs',
                    fieldName: 'proAndLossStatDocs',
                    label: 'Profit and Loss Statements of Foreign Company'
                },  
            ],
        }
    },
    methods: {
        updateDocumentsAction() {
            Object.assign(this.formerrors, { msg: "" });
            this.$validator.validateAll('documentsform').then((result) => {
                if (result) {
                    let postData = {
                       // "documents": {},
                        "typeName": "",
                        "subTypeName": "",
                        "petitionId": '',
                        "today": null
                    }
                    let documents = {}
                    let usaDocuments = {};
                    let foreignDocuments = {};
                    let spouseDocs= {};
                    let isUploaded = false  
                    if(this.callFromSponsorDocs){ 
                        _.forEach(Object.entries(this.petition.sponsorInfo.documents), (val, key) => {
                            if (this.checkProperty(val, "length") > 1) {
                                let docKey = val[0];
                                let docs = val[1];
                                documents[docKey] = []
                                let newDocuments = _.filter(docs, { "isNew": true })
                                if (this.checkProperty(newDocuments, "length") > 0) {
                                    isUploaded = true;
                                    documents[docKey] = newDocuments
                                }
                            }
                        })
                    }
                    else if(this.callFromPetitionerDocs){ 
                        _.forEach(Object.entries(this.petition.petitionerQuestInfo.usaCompanyDocuments), (val, key) => {
                            if (this.checkProperty(val, "length") > 1) {
                                let docKey = val[0];
                                let docs = val[1];
                                usaDocuments[docKey] = []
                                let newDocuments = _.filter(docs, { "isNew": true })
                                if (this.checkProperty(newDocuments, "length") > 0) {
                                    isUploaded = true;
                                    usaDocuments[docKey] = newDocuments
                                }
                            }
                        })
                        _.forEach(Object.entries(this.petition.petitionerQuestInfo.foreignCompanyDocuments), (val, key) => {
                            if (this.checkProperty(val, "length") > 1) {
                                let docKey = val[0];
                                let docs = val[1];
                                foreignDocuments[docKey] = []
                                let newDocuments = _.filter(docs, { "isNew": true })
                                if (this.checkProperty(newDocuments, "length") > 0) {
                                    isUploaded = true;
                                    foreignDocuments[docKey] = newDocuments
                                }
                            }
                        })
                    }
                    else{
                        _.forEach(Object.entries(this.petition.documents), (val, key) => {
                        if (this.checkProperty(val, "length") > 1) {
                            let docKey = val[0];
                            let docs = val[1];
                            documents[docKey] = []
                            let newDocuments = _.filter(docs, { "isNew": true })
                            if (this.checkProperty(newDocuments, "length") > 0) {
                                isUploaded = true;
                                documents[docKey] = newDocuments
                            }
                        }
                    })
                    }
                    
                    if(this.checkProperty(this.petition.dependentsInfo,'spouse')  && this.checkProperty(this.petition.dependentsInfo,'spouse', 'documents') && this.showSpouseDocs ){
                        _.forEach(Object.entries(this.petition.dependentsInfo.spouse.documents), (val, key) => {
                        if (this.checkProperty(val, "length") > 1) {
                            let docKey = val[0];
                            let docs = val[1];
                            spouseDocs[docKey] = []
                            let newDocuments = _.filter(docs, { "isNew": true })
                            if (this.checkProperty(newDocuments, "length") > 0) {
                                isUploaded = true;
                                spouseDocs[docKey] = newDocuments
                            }
                        }
                    })
                    }
                   
                    if (!isUploaded) {
                        Object.assign(this.formerrors, { msg: 'Atleast one document is required.' });
                        return true;
                    }
                    if(this.showSpouseDocs){
                        postData['spouseDocuments'] = _.cloneDeep(spouseDocs);
                    }
                    if(this.callFromSponsorDocs){
                        postData['sponsorDocuments'] = _.cloneDeep(documents);
                    }else if(this.callFromPetitionerDocs){ 
                        postData['usaCompanyDocuments'] = _.cloneDeep(usaDocuments);
                        postData['foreignCompanyDocuments'] = _.cloneDeep(foreignDocuments);
                    }
                    else{
                        postData['documents'] = {}
                        postData['documents'] = _.cloneDeep(documents);
                    }
                    //postData['documents'] = _.cloneDeep(documents);
                    postData['typeName'] = this.checkProperty(this.getPetitionDetails, "typeDetails", "name")
                    postData['subTypeName'] = this.checkProperty(this.getPetitionDetails, "subTypeDetails", "name")
                    postData['petitionId'] = this.checkProperty(this.getPetitionDetails, "_id");
                    postData['today'] = moment().format("YYYY-MM-DD")
                    this.documensUpdating = true;
                    let path = "/petition/add-additional-documents";
                    if (this.checkProperty(this.getPetitionDetails, 'type') == 3 && [15].indexOf(this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'id')) > -1) {
                        path = "/perm/add-additional-documents";
                    }
                    this.$store.dispatch("commonAction", { "data": postData, "path": path })
                    .then(response => {
                        //lca_request_msg
                        this.showToster({ message: response.message, isError: false });
                        this.documensUpdating = false;
                        if(this.callFromPetitionerDocs){
                            this.$emit('openEditDocs', false)
                        }else{
                            this.$emit('reloadCaseDetails')
                        }
                    })
                    .catch((error) => {
                        Object.assign(this.formerrors, { msg: error });
                        this.documensUpdating = false;
                    })
                }
            })
        },
        emitUploadingAction(data){
            if(_.has(data,'docMainCategory')){
                _.map(this[data['docMainCategory']],(item)=>{
                    if(item['fieldName'] == data['fieldName']){
                        item = Object.assign( item ,{ "fileUploading": false})
                        item['fileUploading'] = data['action'] 
                    }
                })
            }
            if(_.has(data,'allFilesAreUploaded')){
                    if(data['allFilesAreUploaded'] && this.checkProperty(data,'uploadFIlesErrors', 'length') >0){
                        let joinedError = '';
                                if(data['uploadFIlesErrors'].length>0){
                                    joinedError = data['uploadFIlesErrors'].join(", ")
                                }
                        this.showToster({
                                        message:joinedError,
                                        isError: true,
                                    });
                    }
                }
            this.checkSubmitBtn(data)
        },
        checkSubmitBtn(data){
            this.documentUploading = false;
            if(_.has(data,'docMainCategory')){
                _.forEach(this[data['docMainCategory']],(item)=>{
                    if(_.has(item,'fileUploading') && item['fileUploading']){
                        this.documentUploading = true;
                        return false;
                    }
                })
            }
        },
        updateL1Docs(callFromSubmit = false){
            let docs =[
                {
                    required: false,
                    fileUploading:false,
                    key: 'leaAgreeForPropOffice',
                    fieldName: 'leaAgreeForPropOffice',
                    label: 'Lease Agreements for the proposed office'
                },
                {
                    required: false,
                    fileUploading:false,
                    key: 'propOrgaChart',
                    fieldName: 'propOrgaChart',
                    label: 'Proposed Organizational Chart'
                }, 
                {
                    required: false,
                    fileUploading:false,
                    key: 'l1AVisaBusiPlan',
                    fieldName: 'l1AVisaBusiPlan',
                    label: 'L1-A Visa Business Plan'
                }, 
                {
                    required: false,
                    fileUploading:false,
                    key: 'bankIndicAndBal',
                    fieldName: 'bankIndicAndBal',
                    label: 'Letter from bank indicating status and balance'
                },
            ]
            let list = _.cloneDeep(this.usaCompanyDocumentslist)
            if(this.checkProperty(this.petition, 'petitionerQuestInfo', 'benfComeToUSOpenNewOffice')){ 
               _.forEach(docs, (item)=>{
                let findObj = _.find(list, {'key':item['key']});
                if(!findObj){
                    list.push(item);
                }
               })
               this.usaCompanyDocumentslist = _.cloneDeep(list)
            }else{
                let tempList = [
                    {
                        required: false,
                        fileUploading:false,
                        key:'incorporationCertDocs',
                        fieldName:"incorporationCertDocs",
                        label:'Certificate of Incorporation'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key:'amendmentCertDocs',
                        fieldName:"amendmentCertDocs",
                        label:'Certificate of Amendment of Certificate of Incorporation'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key:'stockCopyCertDocs',
                        label:'Copy of stock certificates',
                        fieldName:"stockCopyCertDocs",
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'curOrgaChart',
                        fieldName: 'curOrgaChart',
                        label: 'Current Organizational Chart '
                    },  
                    {
                        required: false,
                        fileUploading:false,
                        key: 'minOfBoardMeetings',
                        fieldName: 'minOfBoardMeetings',
                        label: 'Minutes of Board Meetings'
                    }, 
                    
                    {
                        required: false,
                        fileUploading:false,
                        key: 'contraExecOfCopyDocs',
                        fieldName: 'contraExecOfCopyDocs',
                        label: 'Copy of the contracts executed'
                    }, 
                    
                    {
                        required: false,
                        fileUploading:false,
                        key: 'auditFinaStatMostRecent',
                        fieldName: 'auditFinaStatMostRecent',
                        label: 'Most recent audited financial statements or Federal Tax Returns'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'productDocs',
                        fieldName: 'productDocs',
                        label: 'Product Documents '
                    }   
                ]
                this.usaCompanyDocumentslist = _.cloneDeep(tempList);
            }
        },
    },
    props:{
        callFromSponsorDocs:{
            type:Boolean,
            default:false
        },
        callFromPetitionerDocs:{
            type:Boolean,
            default:false
        },
        showSpouseDocs:{
            type:Boolean,
            default:false
        },
        petition: {
            type: Object,
            default: null,
        },
        fieldsArray:{
            type: Array,
            default: [],
        },
        benDocumentList:{
            type: Array,
            default: [],
        },
        spouseDocumentList:{
            type: Array,
            default: [],
        },
    },
    components: {
        casedocumentslist,
        fileUploadNote
    },
    computed: {

    },
    mounted() {
        if(this.callFromPetitionerDocs){
            this.updateL1Docs();
        }
        if(this.checkProperty(this.benDocumentList, 'length')>0){
            this.documentslist = _.cloneDeep(this.benDocumentList);
        }
        if(this.checkProperty(this.spouseDocumentList, 'length')>0){
            this.spouseDocsList = _.cloneDeep(this.spouseDocumentList);
        }
        if(this.checkProperty(this.petition, 'dependentsInfo', 'spouse') && this.checkProperty(this.petition['dependentsInfo'],'spouse','documents') && this.showSpouseDocs){
            this.spouseDocuments['documents'] = _.cloneDeep(this.checkProperty(this.petition['dependentsInfo'],'spouse','documents'))
        }
        this.formerrors.msg = '';
        this.showEdit = true
    }
}

</script>